// extracted by mini-css-extract-plugin
module.exports = {"inspection-data":"style_inspection-data__3op3f"};